"use client";
import React, { AnchorHTMLAttributes } from "react";
import Link, { LinkProps } from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { analytics } from "lib/segment";

interface LinkTrackersProps extends LinkProps {
  target?: AnchorHTMLAttributes<HTMLAnchorElement>["target"];
  className?: string;
  segmentMsg: string;
  segmentOpt: Record<string, any>;
  children: React.ReactNode;
}

export const LinkTrackers: React.FC<LinkTrackersProps> = ({
  href,
  target = "_self",
  className,
  segmentMsg,
  segmentOpt,
  children,
  ...linkProps
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const queryString = searchParams && Array.from(searchParams.entries())
    .filter(([key]) => key.toLowerCase().startsWith("utm_"))
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  const handleOnClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const currentPath = pathname || window.location.pathname;
    const fullPath = queryString
      ? `${currentPath}?${queryString}`
      : currentPath;

    if (target === "_blank") e.preventDefault();

    if (
      typeof window !== "undefined" &&
      (window.OnetrustActiveGroups == undefined ||
        window.OnetrustActiveGroups?.includes("2"))
    ) {
      analytics.track(segmentMsg, {
        ...segmentOpt,
        url: fullPath,
        page_base_url: baseUrl,
        page_full_url: baseUrl + fullPath,
      });
    }

    if (target === "_blank") {
      window.open(typeof href === "string" ? href : (href?.pathname || ""), target);
    }
  };

  const hrefString = typeof href === "string" ? href : (href?.pathname || "");

  return (
    <>
      <Link
        href={
          hrefString.startsWith("#")
            ? "/" +
              `${queryString && !hrefString.includes("utm_") ? `?${queryString}` : ""}` +
              hrefString
            : hrefString +
              `${queryString && !hrefString.includes("utm_") ? `?${queryString}` : ""}`
        }
        {...linkProps}
        target={target}
        onClick={handleOnClick}
        className={className}
      >
        {children}
      </Link>
    </>
  );
};
